<!-- Overview table -->
<app-overview-table></app-overview-table>

<div class="row">
    <div class="col-lg-9">

        <!-- Map -->
        <app-plant-map></app-plant-map>

    </div>

    <div class="col-lg-3">
        <div class="row">
            <div class="col-md-6 col-lg-12">

                <!-- Graph -->
                <app-plant-status-graph></app-plant-status-graph>

            </div>
            <div class="col-md-6 col-lg-12">

                <!-- Savings -->
                <app-savings></app-savings>
                    
            </div>
        </div>
    </div>
</div>

<!-- Plant list -->
<app-plant-list-table></app-plant-list-table>